import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { PreSetRowProps } from '../SetRowTypes'
import LabelFont from '../../../../Theme/Fonts/Label'
import SetRowTemplate from '../Template'

const PreSetRow: FunctionComponent<PreSetRowProps> = ({
    homeCompetitor,
    awayCompetitor,
    caption,
    onPressMatch,
    hideImage,
    winner,
    additionalField,
    additionalFieldOffset,
    paddingTop,
    borderRadius,
    noExpand,
}) => (
    <SetRowTemplate
        homeCompetitor={homeCompetitor}
        awayCompetitor={awayCompetitor}
        winner={winner}
        hideImage={hideImage}
        onPressMatch={onPressMatch}
        additionalField={additionalField}
        additionalFieldOffset={additionalFieldOffset}
        paddingTop={paddingTop}
        borderRadius={borderRadius}
        noExpand={noExpand}
    >
        <Grid center noExpand width={[80, 120]}>
            <LabelFont numberOfLines={1}>{caption}</LabelFont>
        </Grid>
    </SetRowTemplate>
)

export default PreSetRow
